import React, { useState } from 'react';
import { linkButtonStyles } from '../../constant/student-details';
import { Dialog } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as CloseIcon } from 'assets/img/svg/CrossIcon.svg';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ReminderDialog from 'modules/outstanding/ReminderDialog';
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { updateRemarksandReminder } from 'modules/outstanding/utils';
import moment from 'moment';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import "../../../../../../modules/outstanding/style.scss";
const RemarkReminderReset = ({ studentDetails, activeApplicationDetails, setApiLoader, userPermissions }) => {
    const [openInfo, setOpen] = useState(false);
    const [reminderDialogOpen, setReminderDialogOpen] = useState(false);
    const [remarkReminderList, setRemarkReminderList] = useState([]);
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = async () => {
        try {
            setApiLoader(true);
            const res = await fetchAllPromisedData(`${endpoint.outstanding.getRemindersByApplicationId}/${activeApplicationDetails?.applicationId}`, true);
            setRemarkReminderList(res || []);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setApiLoader(false);
            setOpen(true);
        }
    }
    const handleOpenReminderDialog = () => {
        setReminderDialogOpen(true);
    }
    const handleCloseReminderDialog = () => {
        setReminderDialogOpen(false);
    }
    const handleSaveRemarks = async (data) => {
        try {
            setApiLoader(true);
            const { remarks, reminderDate } = data;
            const req = {
                applicationId: activeApplicationDetails?.applicationId,
                remark: remarks,
                reminderDate: reminderDate ? moment(reminderDate).format("YYYY-MM-DD") : null
            }
            const resp = await updateRemarksandReminder(req);
            if (resp?.code === 200) {
                successToast(resp?.message)
                await handleOpen();
            }
        }
        catch (err) {
            console.error("Update Status Error:", err);
        } finally {
            setApiLoader(false);
        }
        handleCloseReminderDialog();
    }
    // Example data, replace with real data as needed
    const remarksList = [
        {
            remark: "CAN'T WAIT TO BUILD THIS OUT!",
            reminderDate: "30-sept-2023",
            createdOn: "20-sept-2023"
        },
        {
            remark: "CAN'T WAIT TO BUILD THIS OUT!",
            reminderDate: "30-sept-2023",
            createdOn: "20-sept-2023"
        },
        {
            remark: "CAN'T WAIT TO BUILD THIS OUT!",
            reminderDate: "30-sept-2023",
            createdOn: "20-sept-2023"
        }
    ];

    const isRightsToEdit = (userPermissions || []).includes('C')||(userPermissions || []).includes('U');
    return (
        <>
            <div style={linkButtonStyles} onClick={handleOpen}>
                Remarks and set reminder
            </div>
            <Dialog open={openInfo} onClose={handleClose} PaperProps={{ sx: { maxWidth: "unset", borderRadius: "12px" } }}>
                <div className="reminder-popup">
                    <div className='d-flex justify-content-betwen align-items-center'>
                        <div className='large-text color-black'>
                            Reminder & Remarks
                        </div>
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{ position: 'absolute', right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                    <div>
                        {(remarkReminderList || remarksList).map((item, idx) => (
                            <div className='mb-4' key={idx}>
                                <div className='regular-large label-color mb-2'>
                                    {item.remark} | Reminder Date {item.reminderDate?moment(item.reminderDate).format("DD-MM-YYYY") : "NA"}
                                </div>
                                <div className='regular-small' style={{ color: '#757575' }}>{item.createdOn? moment(item.createdOn).format("DD-MMM-YYYY"): ""}</div>
                            </div>
                        ))}
                        <AButton
                            variant="primary_filled"
                            onClick={handleOpenReminderDialog}
                            disabled={!isRightsToEdit}
                            className='mt-2 w-100 btn-left-0 '
                        >
                            Add
                        </AButton>
                    </div>
                </div>
            </Dialog>
            <ReminderDialog
                open={reminderDialogOpen}
                onClose={handleCloseReminderDialog}
                onSave={handleSaveRemarks}
                userPermissions={userPermissions}
            />
        </>
    )
}
export default RemarkReminderReset